if (!window.relatedProductsInteractionsInitialized) {
  window.relatedProductsInteractionsInitialized = true;

  const getInteractionContext = (target) => {
    const item = target.closest('.related-products__item');
    const block = item?.closest('related-products-block');
    const label = block?.querySelector('[data-current-shape]');

    return item && block && label ? { item, block, label } : null;
  };

  const handleItemEnter = (event) => {
    const context = getInteractionContext(event.target);

    if (!context) return;

    context.block.dataset.defaultShape ||= context.label.textContent;
    context.label.textContent = context.item.dataset.shape || 'No shape';
  };

  const handleItemLeave = (event) => {
    const context = getInteractionContext(event.target);

    if (!context || context.item.contains(event.relatedTarget)) return;

    context.label.textContent = context.block.dataset.defaultShape || '';
  };

  document.addEventListener('mouseover', handleItemEnter);
  document.addEventListener('mouseout', handleItemLeave);
  document.addEventListener('focusin', handleItemEnter);
  document.addEventListener('focusout', handleItemLeave);
}
